import { useEffect, useState } from 'react'
import { Box, Typography, Button } from '@mui/material'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import { useTheme } from '@/contexts/ThemeContext'
import { useWallet } from '@/hooks/useWallet'
import { ConnectionStatus } from '@/constants/connectionStatus'

export default function Landing() {
  const { connectWallet, status } = useWallet()
  const [animate, setAnimate] = useState(false)
  const { colors, fontFamily } = useTheme()

  useEffect(() => {
    setAnimate(true)
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 100px)',
        textAlign: 'center',
        px: { xs: 2, sm: 4 },
      }}
    >
      <Box
        sx={{
          opacity: animate ? 1 : 0,
          transform: animate ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 1s ease, transform 1s ease',
          mb: 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: colors.primary,
            fontSize: { xs: '40px', sm: '60px', md: '80px' },
            fontWeight: 700,
            textShadow: `0 0 20px ${colors.primaryShadow}, 0 0 40px ${colors.primaryShadow}`,
            mb: 2,
            fontFamily: fontFamily,
          }}
        >
          Admin Dashboard
        </Typography>
        <Typography
          variant="h5"
          sx={{
            color: colors.text,
            fontSize: { xs: '18px', sm: '24px', md: '28px' },
            opacity: 0.8,
            mb: 6,
            fontFamily: fontFamily,
          }}
        >
          Connect your MetaMask wallet to get started
        </Typography>
      </Box>

      <Box
        sx={{
          opacity: animate ? 1 : 0,
          transform: animate ? 'scale(1)' : 'scale(0.9)',
          transition: 'opacity 1s ease 0.3s, transform 1s ease 0.3s',
        }}
      >
        <Button
          variant="contained"
          onClick={connectWallet}
          disabled={status === ConnectionStatus.Connecting}
          size="large"
          startIcon={<AccountBalanceWalletIcon />}
          sx={{
            backgroundColor: colors.primary,
            color: colors.background,
            fontWeight: 700,
            fontSize: { xs: '16px', sm: '18px', md: '20px' },
            px: { xs: 4, sm: 6, md: 8 },
            py: { xs: 1.5, sm: 2, md: 2.5 },
            textTransform: 'uppercase',
            boxShadow: `0 0 30px ${colors.primaryShadow}`,
            '&:hover': {
              backgroundColor: colors.primary,
              opacity: 0.9,
              boxShadow: `0 0 40px ${colors.primaryShadow}`,
              transform: 'scale(1.05)',
            },
            transition: 'all 0.3s ease',
            '&.Mui-disabled': {
              backgroundColor: colors.text,
              color: colors.background,
            },
          }}
        >
          {status === ConnectionStatus.Connecting
            ? 'Connecting...'
            : 'Connect Wallet'}
        </Button>
      </Box>

      <Box
        sx={{
          mt: 8,
          display: 'flex',
          gap: 4,
          flexWrap: 'wrap',
          justifyContent: 'center',
          opacity: animate ? 1 : 0,
          transition: 'opacity 1s ease 0.6s',
        }}
      ></Box>
    </Box>
  )
}
